export class Analytics
{
	static emitSplitEvent(experimentId: string, splitGroup: string): void
	{
		const eventName = window.BX?.Network?.AnalyticsEventType?.AB_TEST_SPLIT;
		const analytics = window.BX?.Network?.Analytics?.getInstance?.();
		if (!eventName || !analytics?.registerEvent)
		{
			return;
		}

		analytics.registerEvent(
			eventName,
			{
				experiment_id: experimentId,
				split_group: splitGroup,
			},
		);
	}
}
